import React from "react"

import RPMEditMain from "./component/RPMEditMain/RPMEditMain"

const RPMEditTreatment = () => <RPMEditMain />

export default RPMEditTreatment
